<script lang="ts">
  import NotificationToggle from "@distributor/svelte/Notifications/NotificationToggle.svelte";
  import OptedOutStatus from "@distributor/svelte/Notifications/OptedOutStatus.svelte";
  import Spinner from "@shared/svelte/Components/Spinner.svelte";

  import DistributorContext from "@modern/services/distributor_context";
  import { HttpPromise } from "@shared/svelte/Modules/ApiService";

  import { DistributorStore } from "@distributor/svelte/Stores/DistributorStore";
  import CurrentUserStore from "@shared/svelte/Stores/CurrentUserStore";

  import type { DistributorUser } from "@shared/types/Distributor";
  import type { Notification } from "@shared/types/Notification";

  import { onMount } from "svelte";

  let distributor: DistributorUser | null = $DistributorStore.currentDistributor;

  let user: any = $CurrentUserStore;
  let phone: string = user.phone || user?.sales_rep?.phone;

  if (DistributorContext.getOnboardingWarnings()) {
    user.phone = "";
  }

  let phoneNotificationToggleEnabled: boolean = true;
  const disablePhoneNotificationToggle = () => {
    phoneNotificationToggleEnabled = false;
  };

  let notifications: Notification[] = [];
  let isLoading: boolean = true;
  const fetchNotifications = async () => {
    const res = await HttpPromise({
      url: "/api/distributor/notifications",
      method: "GET",
    });
    notifications = res;
    isLoading = false;
  };

  onMount(() => {
    fetchNotifications();
  });

  const updateNotifications = notification => {
    notifications.map(n => {
      if (n.name == notification.name) {
        n.email_preference = notification.email_preference;
        n.phone_preference = notification.phone_preference;
      }
      return n;
    });
  };

  const filterEmailNotifications = notifications => {
    return notifications.filter(notification => {
      return (
        notification.name !== "sell_sheet_cloned_to_rep" ||
        (notification.name === "sell_sheet_cloned_to_rep" && distributor.uses_sell_sheets)
      );
    });
  };
</script>

{#if isLoading}
  <Spinner />
{:else}
  <div class="fizz-styles">
    <div class="fizz-surface fizz-inset-square-12 fizz-stack-16">
      <h4 class="fizz-heading-4">Notifications</h4>
    </div>

    <div class="fizz-surface fizz-margin-auto fizz-inset-square-24" style="max-width: 800px;">
      <div class="fizz-text-center">
        <p class="fizz-text-large fizz-text-strong">Email</p>
        <p>{user.email}</p>
      </div>
      <div class="fizz-inset-square-24" data-testid="email-notifications">
        {#each filterEmailNotifications(notifications) as notification}
          <NotificationToggle type={"email"} {notification} {updateNotifications} />
        {/each}
      </div>

      <div class="fizz-text-center">
        <div class="fizz-text-strong fizz-text-large">Phone</div>
        <div>{phone ? phone : "Add a phone number to turn on SMS/text notifications"}</div>
      </div>

      <OptedOutStatus onBlockCallback={disablePhoneNotificationToggle} />

      <div class="fizz-inset-square-24" data-testid="phone-notifications">
        {#each notifications as notification}
          {#if notification.uses_phone && phone}
            <NotificationToggle
              {notification}
              {updateNotifications}
              type={"phone"}
              disableToggle={!phoneNotificationToggleEnabled}
            />
          {/if}
        {/each}
      </div>
    </div>
  </div>
{/if}
